/* Copyright (c) 2017 Backpack Health LLC */

import { connect } from 'react-redux';

import DeleteAccountSurvey from './DeleteAccountSurvey';

import NavigationActions from '../redux/NavigationActions';

import RouteNames from '../RouteNames';

import { getLoggedInUser } from '../redux/reduxSelectors';
import { selectors as listSelectors } from '../../redux/ducks/lists/lists';
import { actions as notificationActions } from '../../redux/ducks/systemNotification';

function mapStateToProps(state, routerProps) {
  const history = routerProps.history;
  const cancelReasons = listSelectors.getCancelReasonList(state);

  return {
    userId: getLoggedInUser(state).data.id,
    cancelReasons,
    isDataLoaded: cancelReasons.length > 0,
    goBack: () => {
      NavigationActions.goBackTo(history, RouteNames.accountSettings());
    },
  };
}

function mapDispatchToProps(dispatch) {
  return {
    showNotification: (messageId) => {
      dispatch(notificationActions.showNotification(messageId));
    },
    dismissNotification: () => {
      dispatch(notificationActions.dismissNotification());
    },
  };
}


export default connect(mapStateToProps, mapDispatchToProps)(DeleteAccountSurvey);
